<template>
    <div class="header_cart_wrap">
        <router-link to="/bag">
            <span class="header_cart_counter">{{count}}</span>
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters([
            'bagCount',
        ]),
        count() {
            return this.bagCount > 99 ? '99+' : +this.bagCount
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/js/components/bag/BagIcon.vue